import React from 'react';
import { Tooltip } from 'react-clone-tippy';

const CustomTooltip = (props) => {
  if (props.disabled) return props.children;
  return <Tooltip {...props}>{props.children}</Tooltip>;
};

export default CustomTooltip;
